import React, { Suspense } from 'react';
import { Redirect, Route, RouteComponentProps, Switch, withRouter } from 'react-router-dom';
import Loader from 'src/components/Loader';
import VerifyOtp from 'src/containers/VerifyOtp';

export const VERIFY_OTP = '/verify';

const Routes: React.FC<RouteComponentProps> = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route path={VERIFY_OTP} component={VerifyOtp} exact />
        <Route
          render={props => {
            if (props.location.pathname.includes('/invite')) {
              window.location.href = `https://rewards.bludot.io/app${props.location.pathname}`;
            }

            return <Redirect to={{ pathname: VERIFY_OTP, search: props.location.search }} />;
          }}
        />
      </Switch>
    </Suspense>
  );
};

export default withRouter(Routes);
